import React from "react";
import "./Footer.css";

export default function Footer(){
    return (
        <div>
        <small>
            <a style={{display: "table-cell"}} href = "https://github.com/Val-netizen/weather-react" target = "_blank" rel = "noopener noreferrer">Open-source code</a> by Valeria Cacciapaglia
        </small>
        </div>
    )
}